export default __webpack_public_path__ + "static/media/Essex_Icons_House.525eca57.svg";